import React from 'react'
import { compose } from 'redux'
import { useDispatch } from 'react-redux'
import ui from 'redux-ui'
import withStyles from 'housecall-ui/dist/DesignSystem/Styles/withStyles'
import Grid from 'housecall-ui/dist/DesignSystem/Layout/Grid/Grid'
import CircularProgress from 'housecall-ui/dist/DesignSystem/Feedback/Progress/CircularProgress'
import Divider from 'housecall-ui/dist/DesignSystem/DataDisplay/Divider/Divider'
import IconButton from 'housecall-ui/dist/DesignSystem/Inputs/Buttons/IconButton'
import Typography from 'housecall-ui/dist/DesignSystem/DataDisplay/Typography/Typography'
import CloseIcon from 'housecall-ui/dist/IconsAndImages/Icons/Close'
import BackArrow from 'housecall-ui/dist/IconsAndImages/Icons/ArrowBack'
import DeleteIcon from 'housecall-ui/dist/IconsAndImages/Icons/Delete'
import {
  HIDE_SPINNER,
  SHOW_SPINNER,
  closeCreateUpdateTask,
  closeTaskDrawer,
} from './Redux/Actions'

const styles = () => ({
  backButtonWrapper: {
    height: 61,
  },
  spinner: {
    padding: 15,
  },
})

const CreateUpdateTaskHeader = ({
  classes,
  showDelete,
  onDeleteTask,
  ui: { showSpinner },
}) => {
  const dispatch = useDispatch()

  const handleCloseAll = () => {
    dispatch(closeCreateUpdateTask())
    dispatch(closeTaskDrawer())
  }
  const handleCloseCreateUpdateTask = () => dispatch(closeCreateUpdateTask())
  const handleDeleteTask = () => onDeleteTask()

  const getCloseButton = () => {
    return (
      <div>
        <IconButton
          onClick={handleCloseAll}
          data-testid='close-task-button'
        >
          <CloseIcon />
        </IconButton>
      </div>
    )
  }

  const getBackButton = () => {
    return (
      <IconButton
        onClick={handleCloseCreateUpdateTask}
        data-testid='back-task-button'
      >
        <BackArrow />
      </IconButton>
    )
  }

  const getDeleteButton = () => {
    let deleteButton = null

    if (showDelete) {
      deleteButton = (
        <div>
          <IconButton
            onClick={handleDeleteTask}
            data-testid='delete-task-button'
          >
            <DeleteIcon />
          </IconButton>
        </div>
      )
    }
    return deleteButton
  }

  const getSpinnerOnAutoSave = () => {
    let spinner = null

    if (showSpinner) {
      spinner = (
        <div className={classes.spinner}>
          <CircularProgress size={20} />
        </div>
      )
    } else if (showSpinner === false) {
      spinner = <Typography className={classes.spinner}>Saved</Typography>
    }
    return spinner
  }

  return (
    <Grid container direction="column" wrap="nowrap">
      <Grid item xs={12}>
        <Grid
          container
          className={classes.backButtonWrapper}
          alignItems="center"
          wrap="nowrap"
        >
          <Grid item xs={6}>
            {getBackButton()}
          </Grid>
          <Grid container item xs={6} justify="flex-end" wrap="nowrap">
            {getSpinnerOnAutoSave()}
            {getDeleteButton()}
            {getCloseButton()}
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <Divider />
      </Grid>
    </Grid>
  )
}

const uiState = {
  state: {
    showSpinner: null,
  },
  reducer: (state, action) => {
    switch (action.type) {
      case SHOW_SPINNER:
        return state.set('showSpinner', true)
      case HIDE_SPINNER:
        return state.set('showSpinner', false)
    }
    return state
  },
}

export default compose(ui(uiState), withStyles(styles))(CreateUpdateTaskHeader)
